import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ImpersonationProvider } from './contexts/ImpersonationContext';
import { ThemeProvider } from './contexts/ThemeContext';
import Layout from './components/Layout';
import DocumentTitle from './components/DocumentTitle';
import Dashboard from './pages/Dashboard';
import Transactions from './pages/Transactions';
import Charts from './pages/Charts';
import AnnualCharts from './pages/AnnualCharts';
import SoldeEvolution from './pages/SoldeEvolution';
import PeriodicTransactions from './pages/PeriodicTransactions';
import SharedExpenses from './pages/SharedExpenses';
import AddSharedExpense from './pages/AddSharedExpense';
import EditSharedExpense from './pages/EditSharedExpense';
import Participants from './pages/Participants';
import SharedExpensesSummary from './pages/SharedExpensesSummary';
import Settings from './pages/Settings';
import Accounts from './pages/Accounts';
import Categories from './pages/Categories';
import Tasks from './pages/Tasks';
import Login from './pages/Login';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Register from './pages/Register';
import AuthCallback from './pages/AuthCallback';
import ForgotPassword from './pages/ForgotPassword';
import VerifyLoginCode from './pages/VerifyLoginCode';
import AcceptTerms from './pages/AcceptTerms';
import ProtectedRoute from './components/ProtectedRoute';
import AdminImpersonate from './pages/AdminImpersonate';
import AdminUsers from './pages/AdminUsers';
import Loans from './pages/Loans';
import AnalyseIA from './pages/AnalyseIA';
import Budgets from './pages/Budgets';
import ImportPage from './pages/ImportPage';
import Onboarding from './pages/Onboarding';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <ImpersonationProvider>
          <Router>
            <DocumentTitle />
            <div className="min-h-screen bg-dark-950 text-white">
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/verify-login-code" element={<VerifyLoginCode />} />
                <Route path="/auth/callback" element={<AuthCallback />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/accept-terms" element={<AcceptTerms />} />
                <Route path="/onboarding" element={<Onboarding />} />
                <Route
                  path="/"
                  element={
                    <ProtectedRoute>
                      <Layout />
                    </ProtectedRoute>
                  }
                >
                  <Route index element={<Dashboard />} />
                  <Route path="transactions" element={<Transactions />} />
                  <Route path="charts" element={<Charts />} />
                  <Route path="annual-charts" element={<AnnualCharts />} />
                  <Route path="solde-evolution" element={<SoldeEvolution />} />
                  <Route path="periodic-transactions" element={<PeriodicTransactions />} />
                  <Route path="shared-expenses" element={<SharedExpenses />} />
                  <Route path="shared-expenses/add" element={<AddSharedExpense />} />
                  <Route path="shared-expenses/edit/:id" element={<EditSharedExpense />} />
                  <Route path="shared-expenses/summary/:annee/:mois" element={<SharedExpensesSummary />} />
                  <Route path="participants" element={<Participants />} />
                  <Route path="accounts" element={<Accounts />} />
                  <Route path="categories" element={<Categories />} />
                  <Route path="budgets" element={<Budgets />} />
                  <Route path="tasks" element={<Tasks />} />
                  <Route path="import" element={<ImportPage />} />
                  <Route path="settings" element={<Settings />} />
                  <Route path="loans" element={<Loans />} />
                  <Route path="analyse" element={<AnalyseIA />} />
                  <Route path="admin/users" element={<AdminUsers />} />
                  <Route path="admin/impersonate" element={<AdminImpersonate />} />
                </Route>
              </Routes>
            </div>
          </Router>
        </ImpersonationProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
